import styled from 'styled-components';
import {
  GRAY_LIGHTER,
  FONT_SIZE_6,
  FONT_SIZE_7,
  GRAY_DARKER,
  FONT_WEIGHT_BOLD,
  FONT_WEIGHT_NORMAL,
  GRAY_LIGHTER_2,
  MAIN_COLOR,
} from '../../styles/variables';
import { flexPosition, fontStyle } from '../../styles/mixins';

export const Text = styled.span`
  font-size: ${FONT_SIZE_6};
`;

export const Content = styled.div`
  padding: 0px 10px;
`;

export const SubItem = styled.div`
  padding: 15px 10px 15px 10px;
  background-color: ${GRAY_LIGHTER_2};
  ${flexPosition('center', 'space-between')}
`;

export const Checkbox = styled.i`
  width: 18px;
  height: 18px;
  border: 2px solid ${GRAY_LIGHTER};
  background-color: ${({ disabled }) => (disabled ? GRAY_LIGHTER : '#fff')};
  border-radius: 3px;
  margin-right: 20px;
  position: relative;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  ${props =>
    props.someChecked
      ? `
    border-color: ${MAIN_COLOR};
    background-color: ${MAIN_COLOR};
    &:after {
      content: '';
      background-color: #FFF;
      width: 12px;
      height: 2px;
      border-radius: 3px;
      display: flex;
      position: absolute;
      top: 45%;
      left: 1px;
    }
  `
      : null}
  ${props =>
    props.checked
      ? `
    border-color: ${MAIN_COLOR};
    background-color: ${MAIN_COLOR};
    &:after {
      content: '';
      top: 0;
      display: flex;
      position: absolute;
      left: 4px;
      background-color: transparent;
      border-radius: 0;
      -webkit-transform: rotate(45deg);
      -ms-transform: rotate(45deg);
      transform: rotate(45deg);
      height: 12px;
      width: 6px;
      border-bottom: 2px solid #FFF;
      border-right: 2px solid #FFF;
    }
  `
      : null}
`;

export const SubTitle = styled.h3`
  ${fontStyle(GRAY_DARKER, FONT_SIZE_6, FONT_WEIGHT_BOLD)}
  margin: 0;
`;

export const Repetitions = styled.ul`
  padding: 0;
  margin: 0;
  ${flexPosition({ align: 'center', justify: 'flex-start' })}
  flex-wrap: wrap;
`;

export const RepItem = styled.li`
  ${flexPosition({ align: 'center', justify: 'flex-start' })}
  margin-right: 20px;
  margin-bottom: 5px;
  margin-top: 5px;
  height: 45px;
`;

export const RepDate = styled.p`
  margin: 0;
  ${fontStyle(GRAY_DARKER, FONT_SIZE_7, FONT_WEIGHT_NORMAL)}
`;



// WEBPACK FOOTER //
// ./src/components/EventListItem/style.js